(function () {
  var isMobile = window.innerWidth <= 767;
  var isDesktop = window.innerWidth >= 1024;

  var mobileBreakpointChecker = function (e) {
    isMobile = e ? e.matches : isMobile;

    // console.log("mobileBreakpointChecker ::: isMobile :", isMobile);

    if (LGEReview && LGEReview.hasOwnProperty("breakpoint"))
      LGEReview.breakpoint();
  };

  var desktopBreakpointChecker = function (e) {
    isDesktop = e ? e.matches : isDesktop;

    // console.log("desktopBreakpointChecker ::: isDesktop :", isDesktop);

    if (LGEReviewDimPopup && LGEReviewDimPopup.hasOwnProperty("breakpoint"))
      LGEReviewDimPopup.breakpoint();
  };

  // 미디어 쿼리
  window
    .matchMedia("(max-width: 767px)")
    .addEventListener("change", mobileBreakpointChecker);
  window
    .matchMedia("(min-width: 1024px)")
    .addEventListener("change", desktopBreakpointChecker);

  var LGEReview = {
    listObserver: null, // 리뷰 리스트 MutationObserver
    messageObserver: null, // 리뷰 내용 MutationObserver
    videoIntersection: null, // 비디오 lazy 위한 IntersectionObserver // BTOCSITE-77169 PDP 리뷰 lzay로딩 적용 - 동영상적용

    init: function () {
      var self = this;

      self.$section = $(".lge-review-wrap");
      self.$prdReviewListUL = self.$section.find("ul.product-review-list");
      self.$filterLayer = $(".popup-wrap.lge-review");

      var initialize = function () {
        self.bindEvents();

        self.initTooltip();
        self.initBestSortAlert();
        self.initPrdList();
      };

      if (!self.$section.closest(".popup-wrap").length) {
        initialize();
      } else {
        // 팝업 내부에 존재 하면 팝업 열리기 직전 초기화
        self.$section
          .closest(".popup-wrap")
          .off(".lge-review")
          .on("modalshown.lge-review", initialize);
      }
    },

    bindEvents: function () {
      var self = this;

      // more btn
      self.$prdReviewListUL
        .off(".lge-review")
        .on("click.lge-review", ".message-wrap .btn-more", function (e) {
          var target = $(e.currentTarget);
          var $msgWrap = target.closest(".message-wrap");

          if ($msgWrap.hasClass("on")) {
            $msgWrap.removeClass("on");
            target.text("더보기");
          } else {
            $msgWrap.addClass("on");
            target.text("접기");
          }
        });

      // 상세필터 팝업 cm -> inch 변경 버튼
      self.$filterLayer
        .off("click.lge-review")
        .on("click.lge-review", ".btn-change-unit", function (e) {
          var target = $(e.currentTarget);
          if (target.hasClass("is-cm")) {
            target.removeClass("is-cm");
            target.addClass("is-inch");
            target.find("span").text("cm로 보기");
          } else {
            target.removeClass("is-inch");
            target.addClass("is-cm");
            target.find("span").text("인치로 보기");
          }
        });

      // 더보기 유무 리사이징 대응
      $(window)
        .off("resizeend.lge-review")
        .on("resizeend.lge-review", function (e) {
          self.$prdReviewListUL
            .find(".message")
            .not(":hidden")
            .each(function () {
              self.checkMoreBtn(this);
            });
        });
    },

    breakpoint: function () {
      var self = this;

      self.carousel();
    },

    // 케러셀 초기화 함수
    carousel: function () {
      var self = this;
      var bestCarousel = self.$section.find(".best-review__carousel");

      if (!isMobile) {
        bestCarousel.vcCarousel({
          infinite: true,
          autoplay: false,
          pauseOnHover: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
          speed: 150,
        });
      } else {
        bestCarousel.vcCarousel("destroy");
      }
    },

    initTooltip: function () {
      var self = this;

      self.$section.find(".ui_tooltip-target").vcTooltipTarget();
    },

    // selectbox 추천순 정렬 옆 ? 아이콘 대응
    initBestSortAlert: function () {
      var self = this;

      var $select = self.$section.find(".sort-select-wrap select");

      var selectBox = $select.vcSelectbox("instance", false);
      if (!selectBox) $select.vcSelectbox();

      var alertBtnHtml =
        '<button type="button" class="btn-sort-alert" data-href="#bestSortAlert" data-control="modal"><span class="blind">추천순 팝업</span></button>';

      var createAlertBtn = function ($target) {
        var $a = $target
          .next(".ui-selectbox-wrap")
          .find('.ui-selectbox-list a[data-text="추천순"]');

        if (!$a.prev("button").length) $a.before(alertBtnHtml);
      };

      createAlertBtn($select);

      // 늦은 초기화 대비
      $select.off(".lge-review").on("selectboxupdate.lge-review", function (e) {
        createAlertBtn($(e.currentTarget));
      });
    },

    // 리뷰 리스트 초기화 함수
    initPrdList: function () {
      var self = this;

      // 중복 호출 방지
      if (
        !self.$prdReviewListUL.length ||
        self.$prdReviewListUL.data("initialized") === true
      ) {
        return;
      }

      self.$prdReviewListUL.find(".message").each(function () {
        self.watchMessage(this);
      });

      self.watchList();
      self.initVideoIntersection(); // BTOCSITE-77169 PDP 리뷰 lzay로딩 적용 - 동영상적용

      self.$prdReviewListUL.data("initialized", true);
    },

    /**
     * video lazy intersection observer 제거
     */
    destroyVideoIntersection: function () {
      var self = this;

      if (self.videoIntersection) {
        self.videoIntersection.disconnect();
        self.videoIntersection = null;
      }
    },

    /**
     * video lazy intersection observer 생성
     */
    initVideoIntersection: function () {
      var self = this;
      var threshold = vcui.dom.getWinHeight();

      self.destroyVideoIntersection();

      self.videoIntersection = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var target = $(entry.target);

            if (entry.isIntersecting) {
              self.changeVideoPreload(self.$section);
            }
          });
        },
        {
          rootMargin: "0px 0px " + threshold + "px 0px",
        }
      );

      if (!!self.$section.length)
        self.videoIntersection.observe(self.$section.get(0));
    },

    /**
     * video preload 변경
     * @param {jQueryElement} $parent video 태그 부모 엘리먼트
     */
    changeVideoPreload: function ($parent) {
      $parent.find("video[preload='none']").attr("preload", "metadata");
    },

    /**
     * 리뷰 텍스트 변경 감시
     * @param {element} el 대상
     */
    watchMessage: function (el) {
      var self = this;

      if (!el) return;

      self.checkMoreBtn(el);

      if (!self.messageObserver) {
        self.messageObserver = new MutationObserver(function (entries) {
          entries.forEach(function (entrie) {
            if (entrie.type === "characterData") {
              self.checkMoreBtn(entrie.target.parentElement);
            }
          });
        });
      }

      self.messageObserver.observe(el, {
        characterData: true,
        attributes: false,
        childList: false,
        subtree: true,
      });
    },

    /**
     * 리뷰 리스트 append 감시
     */
    watchList: function () {
      var self = this;
      var $listWrap = self.$section.find("ul.product-review-list");

      if (!$listWrap.length) return;

      if (!self.listObserver) {
        self.listObserver = new MutationObserver(function (entries, observe) {
          entries.forEach(function (entrie) {
            if (entrie.type === "childList" && !!entrie.addedNodes.length) {
              entrie.addedNodes.forEach(function (el) {
                if (el.tagName === "LI") {
                  self.watchMessage(el.querySelector(".message"));
                  self.changeVideoPreload($(el));
                }
              });
            }
          });
        });
      }

      self.listObserver.observe($listWrap.get(0), { childList: true });
    },

    /**
     * 더보기 버튼 노출 여부 체크 함수
     * @param {element} el 대상
     */
    checkMoreBtn: function (el) {
      var self = this;
      var lineHeight = parseInt(window.getComputedStyle(el).lineHeight);
      var maxLine = 5; //리뷰 텍스트가 pc 5줄 / 모바일 5줄 미만일 경우 더보기 버튼 숨김 처리 BTOCSITE-65893

      // console.log(el, el.scrollHeight , lineHeight * maxLine);

      if (!isNaN(lineHeight)) {
        el.nextElementSibling.classList.toggle(
          "hide",
          el.scrollHeight < lineHeight * (maxLine + 1) // ios 맥북은 el.scrollHeight 가 win 보다 +1 크게 찍혀 넉넉히 maxLine + 1 후 <= 대신 < 로 비교
        );
      }
    },
  };

  // 팝업
  var LGEReviewDimPopup = {
    resizeObservers: null, // lazy 후 swiper 높이 재설정을 위한 리사이즈 옵저버
    isVirtualSwiper: true, // virtual 사용 유무
    current: 0, // 현재 페이지 index
    total: 0, // 총 페이지 index
    ignorePrevEvent: false, // createSideSlide 시 prev 이벤트 방지 flag
    ignoreNextEvent: false, // createSideSlide 시 next 이벤트 방지 flag

    init: function () {
      var self = this;
    },

    breakpoint: function () {
      var self = this;

      self.destroyResizeObserver();
      self.initGalleryPopup();
    },

    initGalleryPopup: function () {
      var self = this;

      // console.log("!!!!! initGalleryPopup");

      $(".ui_review_slider").each(function () {
        var $galleryPopWrap = $(this).closest(".popup-wrap");

        $galleryPopWrap.off(
          "modalshow.lge-review-dim modalshown.lge-review-dim modalhidden.lge-review-dim"
        );

        if (isDesktop) {
          // 데스트탑
          // swiper 제거
          self.destroySwiper($galleryPopWrap);

          if (!$galleryPopWrap.is(":hidden")) {
            // 반응형 대응 - 팝업 열린 상태에서 desktop 으로 breakpoint 이벤트 발생 시
            self.initVcGallery($galleryPopWrap);
          } else {
            // 팝업 열기 전 데스크탑
            $galleryPopWrap.on(
              "modalshow.lge-review-dim modalshown.lge-review-dim",
              function (e) {
                var target = $(e.currentTarget);

                switch (e.type) {
                  case "modalshow":
                    // 초기화
                    self.initVcGallery(target);
                    break;
                  case "modalshown":
                    // width 확정 후 갱신
                    target.find(".rv-visual-slider").vcGallery("refresh");

                    target.one("modalhidden.lge-review-dim", function (e) {
                      // destroy
                      $(e.currentTarget)
                        .find(".rv-visual-slider")
                        .vcGallery("destroy");
                    });

                    break;
                  default:
                } // end switch
              }
            );
          }
        } else {
          // 모바일
          $galleryPopWrap.find(".rv-visual-slider").vcGallery("destroy");

          if (!$galleryPopWrap.is(":hidden")) {
            // 반응형 대응 - 팝업 열린 상태에서 mobile 으로 breakpoint 이벤트 발생 시
            self.initSwiper($galleryPopWrap.find(".swiper"));
          } else {
            // 팝업 열기 전 모바일
            $galleryPopWrap.on("modalshown.lge-review-dim", function (e) {
              var target = $(e.currentTarget);

              self.initSwiper(target.find(".swiper"));
            });
          }
        }
      });
    },

    /**
     * 데스크탑 갤러리 초기화
     * @param {jQueryElement} $popup 팝업
     */
    initVcGallery: function ($popup) {
      var self = this;

      $popup.find(".rv-visual-slider").vcGallery({
        viewerSelector: ".ui_carousel_image_slider",
        thumbnailSelector: ".rv-visual-list-wrap .tabs-wrap-new",
      });

      $popup.find(".review-pagination button").show();
    },

    /**
     * 모바일 스와이프 초기화
     *
     * virtual + loop 기능은 Swiper 9.1.x 부터 지원하므로 현재 v8.2.4 기준 createSideSlide() 통해 커스텀 ( js/libs/ 에 swiper 다른 버전만 4개라 더 추가하지 않으려 )
     * 단 followFinger: false 통해 drag 포기하고 createAntiTouch() 통해 안정성 확보 ( darg 효과 꼭 필요하다면 v9.1.x 이상 버전 추가 고려 )
     * isVirtualSwiper: false 통해 일반 swiper로 수동 전환 가능
     *
     * @param {jQueryElement} $swiper
     */
    initSwiper: function ($swiper) {
      // console.log("!!!!! initSwiper");
      var self = this;

      if (!$swiper.length) return;

      var $popupElm = $swiper.closest(".popup-wrap");

      var opts = {};

      if (self.isVirtualSwiper) {
        $swiper.find(".swiper-wrapper").empty();
        opts = {
          loop: false,
          followFinger: false,
          virtual: {
            cache: true,
            renderSlide: function (slide, index) {
              return '<div class="swiper-slide"></div>';
            },
            slides: ["initial"],
          },
        };
      } else {
        self.setCurrentIndex($swiper); // initialSlide 위해 self.current 선확정
        opts = {
          loop: $swiper.find(".swiper-slide").length > 1,
          initialSlide: self.current,
        };
      }

      self.changePagination($swiper, true); // self.total 선확정

      new Swiper(
        $swiper.get(0),
        Object.assign(
          {
            slidesPerView: 1,
            spaceBetween: 30,
            preventInteractionOnTransition: true,
            observer: true,
            autoHeight: true,
            on: {
              slideNextTransitionStart: function (swiper) {
                self.customPosition(swiper || this, "slideNextTransitionStart");
              },
              slideNextTransitionEnd: function (swiper) {
                self.customPosition(swiper || this, "slideNextTransitionEnd");
                self.changeSwiper(swiper || this, "slideNextTransitionEnd");
              },
              slidePrevTransitionStart: function (swiper) {
                self.customPosition(swiper || this, "slidePrevTransitionStart");
              },
              slidePrevTransitionEnd: function (swiper) {
                self.customPosition(swiper || this, "slidePrevTransitionEnd");
                self.changeSwiper(swiper || this, "slidePrevTransitionEnd");
              },
              activeIndexChange: function (swiper) {
                self.changeSwiper(swiper || this, "activeIndexChange");
              },
              init: function (swiper) {
                self.changeSwiper(swiper || this, "init");
              },
            },
          },
          opts
        )
      );

      $popupElm.find(".rv-move-wrap").toggle(self.total > 1);
      $popupElm.find(".review-pagination button").toggle(self.total > 1);

      var $navigation = $popupElm.find(".review-pagination");
      $navigation
        .off("click.lge-review-dim")
        .on("click.lge-review-dim", "button", function (e) {
          var target = $(e.currentTarget);
          var $swiper = target
            .closest(".review-pagination")
            .prevAll(".pop-conts")
            .find(".swiper");

          if (!!$swiper.length && $swiper[0].swiper) {
            var swiper = $swiper[0].swiper;

            if (target.hasClass("swiper-button-prev")) {
              swiper.slidePrev();
            } else if (target.hasClass("swiper-button-next")) {
              swiper.slideNext();
            }
          }
        });

      if (self.total > 1) self.guideArrowBtn($popupElm);
    },

    // 스크롤 1개로 구현되어 있기에 스와이프 되기 직전에 현재 스크롤 위치 css 로 강제 조정하여 어색하지 않도록하기 위한 함수
    customPosition: function (swiper, type) {
      var self = this;

      if (!swiper.initialized) return;

      var $swiper = $(swiper.el);
      var $scrollTarget = $swiper.closest(".pop-conts");
      var beforeScrollTop = parseInt($scrollTarget.data("before-scroll-top"));
      var scrollTop = !isNaN(beforeScrollTop) ? beforeScrollTop : 0;

      var slideSlideData = self.getSwiperSideState(swiper);

      switch (type) {
        case "slideNextTransitionStart":
        case "slideNextTransitionEnd":
          $(slideSlideData.prevElms)
            .find(".pop-review-wrap")
            .css({
              marginTop: type === "slideNextTransitionStart" ? -scrollTop : "",
            });
          break;

        case "slidePrevTransitionStart":
        case "slidePrevTransitionEnd":
          $(slideSlideData.nextElms)
            .find(".pop-review-wrap")
            .css({
              marginTop: type === "slidePrevTransitionStart" ? -scrollTop : "",
            });
          break;
        default:
      }
    },

    /**
     * 스와이프 제거
     * @param {jQueryElement} $swiper
     */
    destroySwiper: function ($swiper) {
      var $target = $swiper.hasClass("swiper-initialized")
        ? $swiper
        : $swiper.find(".swiper-initialized");

      $target.each(function (_, el) {
        var swiper = $(el)[0].swiper;

        if (swiper !== undefined) {
          swiper.destroy(true, true);
          // console.log("!!!!! destroySwiper", swiper);
        }
      });
    },

    /**
     * 스와이퍼 공통 변경 함수
     * @param {swiper} swiper swiper instance
     * @param {string} type event 타입
     */
    changeSwiper: function (swiper, type) {
      var self = this;

      var $swiper = $(swiper.el);
      var $popupElm = $swiper.closest(".popup-wrap");

      if ($popupElm.is(":hidden")) return;

      var isTrigger = false;

      if (self.isVirtualSwiper) {
        if (type === "init") {
          //console.log("xxxx init event");
          isTrigger = self.createSideSlide(swiper);
        } else if (type === "slidePrevTransitionEnd" && !self.ignorePrevEvent) {
          //console.log("xxxx prev event");
          isTrigger = self.createSideSlide(swiper, "prev");
        } else if (type === "slideNextTransitionEnd" && !self.ignoreNextEvent) {
          //console.log("xxxx next event");
          isTrigger = self.createSideSlide(swiper, "next");
        }
      } else {
        if (swiper.initialized) {
          var direct;
          if (type === "slidePrevTransitionEnd") {
            direct = "prev";
          } else if (type === "slideNextTransitionEnd") {
            direct = "next";
          }

          self.setCurrentIndex($swiper, direct);
          self.changePagination($swiper);
        }

        var $prevSlide = $(swiper.slides).eq(swiper.previousIndex); // init 중 "transitionEnd" 와 구분하기 위해

        if (type === "init") {
          isTrigger = true;
        } else if (
          swiper.initialized &&
          (type === "slidePrevTransitionEnd" ||
            type === "slideNextTransitionEnd") &&
          !$prevSlide.is(".swiper-slide-duplicate")
        ) {
          // swiper slide 변경 후
          var prevIdx = parseInt($prevSlide.attr("data-swiper-slide-index"));
          if (prevIdx === self.current) return; // 반복 시작점 "transitionEnd" 이벤트 중복 호출 방지

          isTrigger = true;
        }
      }

      if (type === "activeIndexChange") {
        var $scrollTarget = $swiper.closest(".pop-conts");
        $scrollTarget
          .data("before-scroll-top", $scrollTarget.scrollTop())
          .scrollTop(0);

        isTrigger = false;
      }

      var slideSlideData = self.getSwiperSideState(swiper);
      var callback = self.refreshSlides(slideSlideData);

      if (isTrigger) {
        $swiper.trigger($.Event("call"), [slideSlideData, callback]); // 외부 trigger
      } /*  else {
        callback(true);
      } */
    },

    /**
     * 빠른 터치 방지용 마크업 생성
     * @param {jQueryElement} $swiper swiper elm
     */
    createAntiTouch: function ($swiper) {
      var self = this;

      self.removeAntiTouch($swiper);

      if (!isDesktop) {
        $swiper.after(
          "<div class='swiper-anti-touch' style='position:fixed;width:100%;height:100%;left:0;top:0;background:rgba(0,0,0,0);z-index:9999;' onclick='return false;'></div>"
        );
      }
    },

    /**
     * 빠른 터치 방지용 마크업 제거
     * @param {jQueryElement} $swiper swiper elm
     */
    removeAntiTouch: function ($swiper) {
      $swiper.nextAll(".swiper-anti-touch").remove();
    },

    /**
     * 좌우 slide 생성 및 반복 이동 함수
     * @param {swiper} swiper swiper instance
     * @param {string} direct "prev" | "next" | undefined
     */
    createSideSlide: function (swiper, direct) {
      var self = this;

      var $slides = $(swiper.slides);
      var $swiper = $slides.closest(".swiper");
      var $slide = $slides.filter(".swiper-slide-active");

      var trigger = true; // $swiper.trigger() 호출 유무
      var n = 2; // 상시 slide 갯수 의미, 실제 갯수 5개면 가상 slide 까지 포함 7개 까지 늘어나고 loop 반복

      self.createAntiTouch($swiper);

      if (!direct) {
        // init 상황
        //console.log("xxxx init slide");
        self.changePagination($swiper, true); // self.total 확정

        if (self.total > 1) {
          self.ignorePrevEvent = true;
          self.ignoreNextEvent = true;
          swiper.virtual.prependSlide(["prev"]);
          swiper.virtual.appendSlide(["next"]);
          self.ignorePrevEvent = false;
          self.ignoreNextEvent = false;
        }
      } else if (direct === "prev" || direct === "next") {
        var $side = $.fn[direct].call($slide); // .prev(), .next()

        if (!$side.length) {
          if (direct === "prev") {
            if (swiper.virtual.slides.length >= self.total + n) {
              // 마지막으로 jump
              //console.log("xxxx last jump");

              self.ignoreNextEvent = true; // 큰수 slideTo로 인한 next 를 막음
              swiper.slideTo(swiper.virtual.slides.length - n, 0);
              self.ignoreNextEvent = false;
            } else {
              //console.log("xxxx prev slide create");
              // 이전 slide 생성
              self.ignoreNextEvent = true; // prependSlide 로 인한 next 막음
              swiper.virtual.prependSlide([direct]);
              self.ignoreNextEvent = false;
            }
          } else if (direct === "next") {
            if (swiper.virtual.slides.length >= self.total + n) {
              // 처음으로 jump
              //console.log("xxxx 0 jump");

              self.ignorePrevEvent = true; // 작은수 slideTo로 인한 prev 를 막음
              swiper.slideTo(1, 0);
              self.ignorePrevEvent = false;
            } else {
              //console.log("xxxx next slide create");
              // 다음 slide 생성
              swiper.virtual.appendSlide([direct]);
            }
          }
        }
      }

      // set current
      self.setCurrentIndex($swiper, direct);

      // change pagination
      self.changePagination($swiper);

      return trigger;
    },

    /**
     * 외부에서 호출될 콜백 함수 정의 반환
     * @param {SwiperState} data
     * @returns {function}
     */
    refreshSlides: function (data) {
      var self = this;

      return function (inner) {
        if (!!data.currentElms.length) {
          // console.log('!!!!! refreshMobileUI 콜백에 의한 초기화');
          self.refreshMobileUI(data);

          self.removeAntiTouch($(data.currentElms).closest(".swiper"));
        }
      };
    },

    /**
     * 페이징 변경
     * @param {jQueryElement} $swiper swiper elm
     * @param {boolean} isNotCur current 마크업 변경 없으려면 true
     */
    changePagination: function ($swiper, isNotCur) {
      var self = this;

      var $popupElm = $swiper.closest(".popup-wrap");
      var $pagination = $popupElm.find(".review-pagination");

      var total = parseInt($pagination.find(".pagination-total").text());
      self.total = total;

      if (!isNaN(self.current) && !isNotCur)
        $pagination.find(".pagination-current").text(self.current + 1);
    },

    /**
     * 현재 index 지정 함수
     * @param {jQueryElement} $swiper swiper elm
     * @param {string} direct "prev" | "next" | undefined
     */
    setCurrentIndex: function ($swiper, direct) {
      var self = this;

      if (!direct) {
        // init
        var $popupElm = $swiper.closest(".popup-wrap");
        self.current =
          parseInt($popupElm.find(".pagination-current").text()) - 1 || 0;

        return;
      }

      var currentIdx = self.current;

      if (direct === "prev") {
        currentIdx--;
      } else if (direct === "next") {
        currentIdx++;
      }

      if (currentIdx < 0) {
        // to last
        self.current = self.total - 1;
      } else if (currentIdx > self.total - 1) {
        // to first
        self.current = 0;
      } else {
        // current
        self.current = currentIdx;
      }
    },

    /**
     * swiper-slide 내부 요소 업데이트 함수
     * @param {SwiperState} data
     */
    refreshMobileUI: function (data) {
      var self = this;

      // lazy 관련 삭제 후 재적용
      self.refreshLazy(data);

      // vcVideoBox 재적용 (videoBox에 destroy 없음)
      self.refreshVideo(data);
    },

    /**
     * lazy 관련 삭제 후 재적용
     * @param {SwiperState} data
     */
    refreshLazy: function (data) {
      var self = this;
      if (!data.currentElms.length) return;

      var $swiper = $(data.currentElms).eq(0).closest(".swiper");
      var $lazyWrapTarget = $swiper.closest(".pop-conts");

      // lazy img
      var lazyLoaderSwitch = $lazyWrapTarget.vcLazyLoaderSwitch(
        "instance",
        false
      );

      if (lazyLoaderSwitch) {
        $lazyWrapTarget.vcLazyLoaderSwitch("destroy");
        $lazyWrapTarget.vcLazyLoaderSwitch({
          selector: $(data.currentElms).find(".media-list"),
        });
      } else {
        $lazyWrapTarget.vcLazyLoaderSwitch({ selector: $lazyWrapTarget });
      }

      // lazy video
      var lazyLoaderSwitchVideo = $lazyWrapTarget.vcLazyLoaderSwitchVideo(
        "instance",
        false
      );

      if (lazyLoaderSwitchVideo) {
        $lazyWrapTarget.vcLazyLoaderSwitchVideo("destroy");
        $lazyWrapTarget.vcLazyLoaderSwitchVideo({
          selector: $(data.currentElms).find(".media-list"),
        });
      } else {
        $lazyWrapTarget.vcLazyLoaderSwitchVideo({ selector: $lazyWrapTarget });
      }

      // update swiper height
      if (!!$swiper.length && $swiper[0].swiper) {
        var swiper = $swiper[0].swiper;
        $lazyWrapTarget
          .off("lazyLoadercomplete")
          .on("lazyLoadercomplete", function (e, lazy) {
            self.initResizeObserver(
              lazy.el.querySelector(".swiper-slide-active"),
              function () {
                swiper.updateAutoHeight(0);
              }
            );
          });
      }
    },

    /**
     * vcVideoBox 적용
     * @param {SwiperState} data
     */
    refreshVideo: function (data) {
      var self = this;

      var $listWrap = $(data.currentElms).find(".rv-info-wrap .media-wrap");

      $listWrap.find("video").each(function (idx, elm) {
        $(elm).parent().vcVideoBox("pause");
      });
    },

    /**
     * 리사이즈 옵저버 생성
     * @param {element} el 대상 element
     * @param {function} fn 완료 함수
     */
    initResizeObserver: function (el, fn) {
      var self = this;

      self.destroyResizeObserver();

      self.resizeObservers = new ResizeObserver(function (entries) {
        entries.forEach(function (entrie) {
          //console.log("!!!!! resizing", entrie.contentBoxSize[0].blockSize);
          if (fn) fn();
        });
      });

      if (el) self.resizeObservers.observe(el);
    },

    /**
     * 리사이즈 옵저버 삭제
     */
    destroyResizeObserver: function () {
      var self = this;

      if (self.resizeObservers) {
        self.resizeObservers.disconnect();
        self.resizeObservers = null;
      }
    },

    /**
     * 가이드성 화살표 fade out
     * @param {jQueryElement} popupElm 팝업
     */
    guideArrowBtn: function (popupElm) {
      var self = this;

      var $swiper = popupElm.find(".swiper");
      var $arrowBtnWrap = popupElm.find(".rv-move-wrap");
      $arrowBtnWrap.clearQueue().stop().fadeIn(0).delay(5000).fadeOut();

      $arrowBtnWrap
        .off("click.lge-review-dim")
        .on("click.lge-review-dim", "button", function (e) {
          var target = $(e.currentTarget);

          if (!!$swiper.length && $swiper[0].swiper) {
            var swiper = $swiper[0].swiper;

            if (target.is(".prev")) {
              swiper.slidePrev();
            } else {
              swiper.slideNext();
            }
          }
        });
    },

    /**
     * swiper 상태 반환
     * @typedef {object} SwiperState
     * @property {element[]} currentElms  활성화 .swiper-slide element 담긴 배열
     * @property {element[]} prevElms     이전 .swiper-slide element 담긴 배열
     * @property {element[]} nextElms     다음 .swiper-slide element 담긴 배열
     * @property {number} currentIdx   현재 index
     * @property {number} prevIdx      다음 index
     * @property {number} nextIdx      이전 index
     */

    /**
     * 좌우 element 및 현재 swiper 상태 반환
     * @param {swiper} swiper swiper instance
     * @returns {SwiperState}
     */
    getSwiperSideState: function (swiper) {
      var self = this;

      var $slides = $(swiper.slides);
      var currentIdx = self.current;
      var prevIdx = currentIdx - 1 < 0 ? self.total - 1 : currentIdx - 1;
      var nextIdx = (currentIdx + 1) % self.total;

      var elms = {};
      if (self.isVirtualSwiper) {
        elms = {
          currentElms: $slides.filter(".swiper-slide-active").toArray(),
          prevElms: $slides.filter(".swiper-slide-prev").toArray(),
          nextElms: $slides.filter(".swiper-slide-next").toArray(),
        };
      } else {
        elms = {
          currentElms: $slides
            .filter(
              "[data-swiper-slide-index=" +
                currentIdx +
                "], .swiper-slide-active"
            )
            .toArray(),
          prevElms: $slides
            .filter("[data-swiper-slide-index=" + prevIdx + "]")
            .toArray(),
          nextElms: $slides
            .filter("[data-swiper-slide-index=" + nextIdx + "]")
            .toArray(),
        };
      }

      return Object.assign(
        {
          currentIdx: currentIdx,
          prevIdx: prevIdx,
          nextIdx: nextIdx,
        },
        elms
      );
    },
  };

  vcui.require(["ui/gallery", "libs/swiper-8.2.4.min"], function () {
    $(function () {
      LGEReview.init();
      LGEReviewDimPopup.init();

      mobileBreakpointChecker();
      desktopBreakpointChecker();
    });
  });
})();
